<template>
    <div id="explanation-wrapper">
        <transition name="fade">
            <div v-show="show">
                <explanation></explanation>

                <div id="do-not-show" key="do-not-show-directive" class = "do-not-show" v-if="show" v-closable=" introClosableAnywhere ? {
                    exclude: ['do-not-show', 'swiper-pagination', 'swiper-slide'],
                    handler: 'hideExplanation',
                    timeout: 100
                } : false">
                    <span @click="toggleSkip">{{'do_not_show_again_intro_2' | lang}} </span> <input v-model="dontShowIntro" type="checkbox">
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import "bootstrap";

// core version + navigation, pagination modules:
import Swiper from 'swiper';
// import style (>= Swiper 6.x)
import 'swiper/css'

export default {
    data() {
        return {
            dontShowIntro: false,
            show: false,
            introClosableAnywhere: Config.settings.introClosableAnywhere || true
        };
    },
    methods: {
        ...mapMutations(['toggleExplanation']),
        hideExplanation() {
            if(this.explanationVisible) {
                if(this.explanationCallback) {
                    this.explanationCallback();
                }
                
                this.toggleExplanation({callback:false, dontShowIntro:this.dontShowIntro});

                this.show = false;
            }
        },
        showEvent() {
            this.show = true;
        },
        toggleSkip() {
          this.dontShowIntro = !this.dontShowIntro
        },
    },
    components: {
        Explanation: resolve => {
            resolve({ 
                components: {
                },
                template: Config.explanation_template,
                data() {
                    return {
                        gameName: Config.game_name.toLowerCase(),
                        gameNameUpper: Config.game_name,
                        logoLink: Config.logoByLanguage,
                        odds: Config.odds,
                        lang: Config.language,
                    };
                },
                computed: {
                    bonuses() {
                        return this.odds.bonus_1_multipliers;
                    }
                },
                mounted() {
                    this.$parent.showEvent();
                    var swiper = new Swiper(".mySwiper", {
                        slidesPerView: 3,
                        loopFillGroupWithBlank: false,
                        spaceBetween: 30,
                        loop: true,
                        spaceBetween: 30,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        }
                    });
                }
            });
        },
    },
    computed: {
        ...mapState([
            'explanationCallback',
            'explanationVisible'
        ]),
    },
    watch: {
      explanationVisible() {
        const el = document.getElementById('fg-container');

        if (this.explanationVisible) {
          el.classList.add('explanation-visible');
        } else {
          el.classList.remove('explanation-visible');
        }
      },
    },
}
</script>

<style>
    #explanation-wrapper .do-not-show {
        position:absolute;
        color:white;
        font-size: 16px;
        right: 10px;
        bottom: 10px;
    }

    #explanation-wrapper .fade-enter-active, .fade-leave-active {
        transition: opacity 0.6s;
    }

    #explanation-wrapper .fade-enter, #explanation-wrapper .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    @media (orientation:portrait) { 
        #explanation-wrapper .do-not-show {
            width: 100%;
            text-align: center;
        }
    }

</style>
